export default __webpack_public_path__ + "static/media/b2b-dash-psychological-icon.ccded355.svg";